var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreviewAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_466_565845",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 17,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 9C1.5 13.575 5.175 17.25 9.75 17.25C14.325 17.25 18 13.575 18 9C18 4.425 14.325 0.75 9.75 0.75C5.175 0.75 1.5 4.425 1.5 9ZM3 9C3 5.25 6 2.25 9.75 2.25C13.5 2.25 16.5 5.25 16.5 9C16.5 12.75 13.5 15.75 9.75 15.75C6 15.75 3 12.75 3 9ZM10.5 9V6C10.5 5.55 10.2 5.25 9.75 5.25C9.3 5.25 9 5.55 9 6V9C9 9.45 9.3 9.75 9.75 9.75C10.2 9.75 10.5 9.45 10.5 9ZM10.425 12.3C10.425 12.375 10.35 12.45 10.275 12.525C10.125 12.675 9.975 12.75 9.675 12.75C9.45 12.75 9.3 12.675 9.15 12.525C9 12.375 8.925 12.225 8.925 12C8.925 11.9121 8.95074 11.85 8.97206 11.7985C8.98713 11.7621 9 11.7311 9 11.7C9 11.625 9.075 11.55 9.15 11.475C9.375 11.25 9.675 11.175 9.975 11.325C10.0125 11.325 10.0312 11.3438 10.05 11.3625C10.0688 11.3813 10.0875 11.4 10.125 11.4C10.2 11.4 10.275 11.475 10.275 11.475C10.3125 11.5125 10.3313 11.55 10.35 11.5875C10.3688 11.625 10.3875 11.6625 10.425 11.7C10.5 11.775 10.5 11.925 10.5 12C10.5 12.0375 10.4813 12.0937 10.4625 12.15C10.4438 12.2062 10.425 12.2625 10.425 12.3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_466_565845)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 18,
    height: 18,
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewAlert);
export default __webpack_public_path__ + "static/media/preview-alert.d5f5267f3d5c831671e1bb8fb1b5c976.svg";
export { ForwardRef as ReactComponent };